import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react'
import { type FC, type PropsWithChildren } from 'react'

import { Button } from '@/components/button/button'
import { DialogDescription, DialogHeader, DialogTitle } from '@/components/dialog/dialog'

import { cn } from '@/lib/utils'

import dolLogo from '@/assets/images/dol-logo.svg'
import nvcLogo from '@/assets/images/nvc-logo.svg'
import uscisLogo from '@/assets/images/uscis-logo.svg'

import { RegisterNvcCase } from './register-nvc-case/register-nvc-case'
import { RegisterUscisAndDolCase } from './register-uscis-and-dol-case/register-uscis-and-dol-case'
import { useContent } from './use-content'

export const Content: FC = () => {
  const { step, setStep } = useContent()

  return (
    <>
      <DialogHeader className="mb-5">
        <DialogTitle>
          {step === 'select-department' && (
            <p className={cn('text-[24px] font-bold leading-[34px]')}>
              Please select Immigration Government Agency to add your case.
            </p>
          )}
          {step !== 'select-department' && (
            <p className={cn('flex items-center', 'text-[24px] font-bold leading-[34px]')}>
              <Button variant="ghost" size="icon" className={cn('mr-2')} onClick={() => setStep('select-department')}>
                <ArrowLeftIcon size={24} />
              </Button>
              Add New Case
            </p>
          )}
        </DialogTitle>
        <DialogDescription hidden>
          Select a Immigration Department first before adding a new case which belongs to this applicant
        </DialogDescription>
      </DialogHeader>
      {step === 'select-department' && (
        <div className={cn('flex flex-col', 'space-y-4')}>
          <DepartmentButton logo={uscisLogo} alt="USCIS logo" onClick={() => setStep('register-uscis-case')}>
            USCIS
          </DepartmentButton>
          {/* replace logo with real one */}
          <DepartmentButton logo={dolLogo} alt="DOL logo" onClick={() => setStep('register-dol-case')}>
            DOL
          </DepartmentButton>
          <DepartmentButton logo={nvcLogo} alt="NVC logo" onClick={() => setStep('register-nvc-case')}>
            NVC
          </DepartmentButton>
        </div>
      )}
      {(step === 'register-uscis-case' || step === 'register-dol-case') && <RegisterUscisAndDolCase />}
      {step === 'register-nvc-case' && <RegisterNvcCase />}
    </>
  )
}

const DepartmentButton = ({
  logo,
  children,
  onClick,
}: PropsWithChildren<{ logo: string; alt: string; onClick: VoidFunction }>) => {
  return (
    <Button
      variant="secondary"
      className={cn(
        'flex items-center justify-start',
        'p-6',
        'h-fit',
        'rounded-[20px]',
        'text-[24px] font-bold leading-[34px] text-black',
        'border border-[#e4e4e7]'
      )}
      onClick={onClick}
    >
      <img src={logo} alt="USCIS logo" className={cn('w-[60px]', 'h-[60px]')} />
      <p className={cn('ml-[30px]')}>{children}</p>
      <p className={cn('ml-auto')}>
        <ArrowRightIcon size={24} />
      </p>
    </Button>
  )
}
